import { render, staticRenderFns } from "./DetalharPostagem.vue?vue&type=template&id=77507552&scoped=true&"
import script from "./DetalharPostagem.vue?vue&type=script&lang=js&"
export * from "./DetalharPostagem.vue?vue&type=script&lang=js&"
import style0 from "./DetalharPostagem.vue?vue&type=style&index=0&id=77507552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77507552",
  null
  
)

export default component.exports